import { createContext } from 'react';

export type AppContextData = {
    setInitialAssetManifest: () => void
};

export const AppContext = createContext<AppContextData>({
    setInitialAssetManifest: () => {},
});
